import React from "react";
import s from "./DrawdownChartLegend.module.scss";
interface DrawdownChartLegendProps {
  t: (toTranslate: string) => string;
  isPdfExport?: boolean;
}

export const DrawdownChartLegend = ({
  t,
  isPdfExport = false,
}: DrawdownChartLegendProps) => {
  const defaultColors = {
    portfolioColor: "var(--portfolio-color)",
    watermarkColor: "var(--illio-chart-watermark-color)",
    drawdownColor: "var(--illio-chart-drawdown-color)",
  };

  const pdfColors = {
    portfolioColor: "rgb(23, 19, 42)",
    watermarkColor: "rgb(63, 170, 164)",
    drawdownColor: "rgb(234, 114, 80)",
  };

  const colors = isPdfExport ? pdfColors : defaultColors;

  return (
    <div
      style={{
        display: "flex",
        gridGap: 20,
        marginTop: -7,
      }}
    >
      <div className={s.item}>
        <span>
          <svg width="20" height="15">
            <circle fill={colors.portfolioColor} r={6} cx={6} cy={6} />
          </svg>
        </span>
        <span>{t("Portfolio")}</span>
      </div>
      <div className={s.item}>
        <span>
          <svg width="20" height="15">
            <circle
              fill="transparent"
              stroke={colors.watermarkColor}
              strokeDasharray="2,2"
              r={6}
              cx={6}
              cy={6}
            />
          </svg>
        </span>
        <span>{t("Watermark")}</span>
      </div>
      <div className={s.item}>
        <span>
          <svg width="20" height="15">
            <circle fill={colors.drawdownColor} r={6} cx={6} cy={6} />
          </svg>
        </span>
        <span>{t("Drawdown")}</span>
      </div>
    </div>
  );
};
